// @ts-check

/**
 * All entries stores a combination of all the entries in all of the
 * different modules
 */

const entryModules = ['incomes', 'expenses', 'actions', 'account-transactions']

const entryGetters = {
  entries: (state, getters, rootState) => {
    const entries = {}

    // Add unique entries from all modules
    entryModules.forEach((entryModule) => {
      rootState[entryModule].entries.forEach((entry) => {
        entries[entry.id] = entry
      })
    })

    return Object.values(entries)
  }
}

export const entryModule = {
  namespaced: true,
  getters: entryGetters
}

export default entryModule
